module.exports = __webpack_public_path__ + "img/dinbiao.53fdacf7.png";